import React, {useEffect, useState} from 'react';
import { Box, Button, Paper, Typography, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import TransportForm from '../components/Transport/TransportForm';
import PutyovkaFormModal from './PutyovkaFormModal';
import LitsenziyaAdd from './LitsenziyaAdd';
import IjaraAdd from './IjaraAdd';
import {toast, ToastContainer} from "react-toastify";
import { Alert, Container, Row, Col } from 'react-bootstrap';
import { BsCheckCircleFill } from 'react-icons/bs';
import PutyovkaService from "../services/PutyovkaService";
import LitsenziyaService from "../services/LitsenziyaService";
import IjaraService from "../services/IjaraService";
import {parseFormattedNumber} from "../utils/formatters";
import PutyovkaWizard from "../components/putyovka";

const TransportAdd2 = () => {
  const [transportCreated, setTransportCreated] = useState(false);
  const [transportId, setTransportId] = useState(null);
  const [openPutyovka, setOpenPutyovka] = useState(false);
  const [openLitsenziya, setOpenLitsenziya] = useState(false);
  const [openIjara, setOpenIjara] = useState(false);
  const [formData, setFormData] = useState({
    id: '',
    transport_id: transportId,
    raqam: '',
    narx: '',
    dan: '',
    gacha: '',
    shafyors: [],
    putyofka_priseps: [],
    putyofka_yonalishs: []
  });
  const [defFormData, setDefFormData] = useState({
    id: '',
    transport_id: transportId,
    raqam: '',
    narx: '',
    dan: '',
    gacha: '',
    shafyors: [],
    putyofka_priseps: [],
    putyofka_yonalishs: []
  });
  const [formDataLitsenziya, setFormDataLitsenziya] = useState({
    transportNumber: '',
    transport_id: '',
    raqam: '',
    dan: '',
    gacha: '',
    izoh: '',
    fayl: null,
    narx: '',
    id: ''
  });
  const [formDataLitsenziyaDef, setFormDataLitsenziyaDef] = useState({
    transportNumber: '',
    transport_id: '',
    raqam: '',
    dan: '',
    gacha: '',
    izoh: '',
    fayl: null,
    narx: '',
    id: ''
  });
  const [formDataIjara, setFormDataIjara] = useState({
    transportNumber: '',
    transport_id: '',
    raqam: '',
    dan: '',
    gacha: '',
    izoh: '',
    fayl: null,
    id: '',
  });
  const [formDataIjaraDef, setFormDataIjaraDef] = useState({
    transportNumber: '',
    transport_id: '',
    raqam: '',
    dan: '',
    gacha: '',
    izoh: '',
    fayl: null,
    id: '',
  });

  const [putyovkaAdded, setPutyovkaAdded] = useState(false);
  const [litsenziyaAdded, setLitsenziyaAdded] = useState(false);
  const [ijaraAdded, setIjaraAdded] = useState(false);

  const handleTransportSubmit = (values) => {
    console.log('Transport created:', values);
    setTransportId(values.id);
    setTransportCreated(true);
  };

  useEffect(() => {
    setFormData({ ...formData, transport_id: transportId });
    setFormDataLitsenziya({ ...formDataLitsenziya, transport_id: transportId });
    setFormDataIjara({ ...formDataIjara, transport_id: transportId });
  }, [transportId]);

  const handlePutyovkaClick = () => {
    setOpenPutyovka(true);
  };
  const handleSavePutyovka = async (e) => {
    e.preventDefault();
    if (transportId && !formData.transport_id) {
      setFormData({ ...formData, transport_id: transportId });
    }
      setFormData({ ...formData, transport_id: transportId });
    if (!formData.transport_id || !formData.raqam || !formData.dan || !formData.gacha || !formData.narx) {
      toast.error("Barcha asosiy maydonlarni to'ldiring!", { position: "bottom-right", autoClose: 3000 });
      return;
    }
    // const data = { ...formData };
    try {
      const amount = parseFormattedNumber(formData.narx);
      const correctedFormData = {
        ...formData,
        narx: amount
      };
      let res = await PutyovkaService.addPutyovka(correctedFormData);
      if (res.success === true) {
        toast.success(`Putyovka qo‘shildi"}`, { position: "bottom-right", autoClose: 3000 });
        setOpenPutyovka(false);
        setPutyovkaAdded(true);
        setFormData(defFormData);
      }else {
        toast.error('Putyovka qoshishda xatolik yuz berdi', { position: "bottom-right", autoClose: 3000 });
      }
    } catch {
      toast.error("Xatolik yuz berdi!");
    }
  };

  const handleSaveLitsenziya = async () => {
    if (!formDataLitsenziya.transport_id || !formDataLitsenziya.raqam || !formDataLitsenziya.dan || !formDataLitsenziya.gacha || !formDataLitsenziya.narx) {
      toast.error("Barcha maydonlarni to'ldiring!", {
        position: "bottom-right",
        autoClose: 3000,
      });
      return;
    }
    const amount = parseFormattedNumber(formDataLitsenziya.narx);
    const data = new FormData();
    data.append('id', formDataLitsenziya.id);
    data.append('transport_id', formDataLitsenziya.transport_id);
    data.append('raqam', formDataLitsenziya.raqam);
    data.append('dan', formDataLitsenziya.dan);
    data.append('gacha', formDataLitsenziya.gacha);
    data.append('narx', amount);
    data.append('izoh', formDataLitsenziya.izoh || '');
    if (formDataLitsenziya.fayl) {
      data.append('fayl', formDataLitsenziya.fayl); // Fayl mavjud bo‘lsa
    }
    console.log('litsenziya add ga keldi')
    console.log(formDataLitsenziya)
    try {
      let res = await LitsenziyaService.addLitsenziya(data);
      if (res.success === true) {
        toast.success(`Litsenziya qo'shildi"}`, {
          position: "bottom-right",
          autoClose: 3000,
        });
        setOpenLitsenziya(false);
        setFormDataLitsenziya(formDataLitsenziyaDef);
        setLitsenziyaAdded(true);
      }else {
        toast.error('Litsenziya qoshishda xatolik yuz berdi', {
          position: "bottom-right",
          autoClose: 3000,
        });
      }
    } catch (err) {
      toast.error("Xatolik yuz berdi!");
    }
  };

  const handleLitsenziyaClick = () => {
    setOpenLitsenziya(true);
  };

  const handleIjaraClick = () => {
    setOpenIjara(true);
  };

  const handleSaveIjara = async () => {
    try {
      if (!formDataIjara.transport_id || !formDataIjara.raqam || !formDataIjara.dan || !formDataIjara.gacha) {
        toast.error("Iltimos, barcha majburiy maydonlarni to'ldiring!", {
          position: "bottom-right",
          autoClose: 3000,
        });
        return;
      }
      const data = new FormData();
      data.append('id', formDataIjara.id);
      data.append('transport_id', formDataIjara.transport_id);
      data.append('raqam', formDataIjara.raqam);
      data.append('dan', formDataIjara.dan);
      data.append('gacha', formDataIjara.gacha);
      data.append('izoh', formDataIjara.izoh || '');
      if (formDataIjara.fayl) {
        data.append('fayl', formDataIjara.fayl); // Fayl mavjud bo‘lsa
      }
      let res = await IjaraService.addIjara(data);
      if (res.success === true) {
        toast.success("Ijara muvaffaqiyatli qo'shildi!", {
          position: "bottom-right",
          autoClose: 3000,
        });
        setOpenIjara(false);
        setFormDataIjara(formDataIjaraDef);
        setIjaraAdded(true);
      }
    } catch (e) {
      console.log(e);
    }
  }

  const handleCloseModal = () => {
    setOpenPutyovka(false);
    setOpenLitsenziya(false);
    setOpenIjara(false);
  };

  const handleClosePutyovkaModal = () => {
    setOpenPutyovka(false);
    setPutyovkaAdded(true);
  }

  return (
    <Box sx={{ width: '100%', p: 3 }}>
      <ToastContainer />
      <Paper elevation={3} sx={{ p: 3, mb: 3 }}>
        <Typography variant="h4" gutterBottom>
          Transport yaratish
        </Typography>

        {!transportCreated ? (
          <TransportForm onSubmit={handleTransportSubmit} initialValues={formData} />
        ) : (
          <Box>
            {/*<Typography variant="h6" color="success.main" gutterBottom>*/}
            {/*  Transport muvaffaqiyatli yaratildi!*/}
            {/*</Typography>*/}
            <Container className="mt-4">
              <Row className="justify-content-center">
                <Col md={8} lg={6}>
                  <Alert variant="success" className="d-flex align-items-center justify-content-center text-center shadow rounded-4 py-4">
                    <BsCheckCircleFill size={28} className="me-3 text-success" />
                    <div>
                      <h5 className="mb-0">Transport muvaffaqiyatli yaratildi!</h5>
                    </div>
                  </Alert>
                </Col>
              </Row>
            </Container>
            <Box sx={{ mt: 4, display: 'flex', flexDirection: 'row', gap: 10 }}>
              <Button 
                variant="contained" 
                color="primary"
                onClick={handlePutyovkaClick}
                fullWidth
                disabled={putyovkaAdded}
                size="medium"
              >
                Putyovka biriktirish
              </Button>
              
              <Button 
                variant="contained" 
                color="warning"
                onClick={handleLitsenziyaClick}
                fullWidth
                disabled={litsenziyaAdded}
                size="medium"
              >
                Litsenziya biriktirish
              </Button>
              
              <Button 
                variant="contained" 
                color="success" 
                onClick={handleIjaraClick}
                fullWidth
                disabled={ijaraAdded}
                size="medium"
              >
                Ijara biriktirish
              </Button>
            </Box>
            <Button
                variant="outlined"
                color="primary"
                sx={{ mt: 3 }}
                fullWidth
                size="medium"
                href="/dashboard/transport"
            >
              Chiqish
            </Button>
          </Box>
        )}
      </Paper>

      {/* Modals for each action */}
      <Dialog open={openPutyovka} onClose={handleCloseModal} maxWidth="lg" fullWidth>
        <DialogTitle>Putevka biriktirish</DialogTitle>
        <DialogContent>
          <PutyovkaWizard transportId={transportId} doNotNavigate={true} onClose={handleClosePutyovkaModal}/>
          {/*<PutyovkaFormModal transportId={transportId} onClose={handleCloseModal}*/}
          {/*                   formData={formData} setFormData={setFormData}*/}
          {/*                   onSave={handleSavePutyovka}*/}
          {/*                   show={openPutyovka}*/}
          {/*                   onHide={handleCloseModal}*/}
          {/*/>*/}
        </DialogContent>
      // </Dialog>

      {/*<Dialog open={openLitsenziya} onClose={handleCloseModal} maxWidth="md" fullWidth>*/}
      {/*  /!*<DialogTitle>Litsenziya biriktirish</DialogTitle>*!/*/}
      {/*  <DialogContent>*/}
          <LitsenziyaAdd showModal={openLitsenziya}
                         setShowModal={setOpenLitsenziya}
                         formData={formDataLitsenziya}
                         setFormData={setFormDataLitsenziya}
                         handleSave={handleSaveLitsenziya}
                         transportId={transportId}
                         onClose={handleCloseModal} />
      {/*  </DialogContent>*/}
      {/*</Dialog>*/}

      {/*<Dialog open={openIjara} onClose={handleCloseModal} maxWidth="md" fullWidth>*/}
      {/*  <DialogTitle>Ijara biriktirish</DialogTitle>*/}
      {/*  <DialogContent>*/}
          <IjaraAdd
              transportId={transportId}
              onClose={handleCloseModal}
              showModal={openIjara}
              setShowModal={setOpenIjara}
              formData={formDataIjara}
              setFormData={setFormDataIjara}
              handleAddSave={handleSaveIjara}
          />
      {/*  </DialogContent>*/}
      {/*</Dialog>*/}
    </Box>
  );
};

export default TransportAdd2;
